<template>
	<div class="customFixed-vue alertPOP darkFadeBG loginInfo">
	    <div class="custom-modal showTabs secondary-color openHeader">
	    	<div class="mainContent">
	    		<div class="topSettingHead position-relative border-bottom p-3">
	    			<p class="f-14 mb-0">{{$t('select_broker') }} </p>
					<span class="closePOP" @click.prevent="$parent.page_type = ''"><feather size="13px" type="x"></feather></span>
	    		</div>
	    		<div class="mainTab-one pb-3">
		    	<form class="updateWrap">
		    		
		    		<div class="form-fields d-flex align-items-center mb-3">
						<select class="selectBox">
							<option value="disabled">{{$t('brokers') }}  </option>
							<option>{{$t('hankotrade') }} </option> 
							<option>{{$t('finpro_trading') }} </option>
							<option>{{$t('coinexx') }} </option>
							<option>{{$t('turnkey_forex') }} </option>
						</select>
					</div>
					
					<div class="fullWidh d-flex align-items-center justify-content-between text-center px-2 my-3">
						<a href="#" class="btn appButton redBG justify-content-center" @click.prevent="$parent.page_type = 'login'">{{$t('back') }}</a>
						<a href="#" class="btn appButton linkBG justify-content-center">{{$t('proceed') }} </a>
					</div>
				</form>
			    </div>
	    	</div>
	    </div>
    </div>
</template>

<script>
export default {
    name: 'login-pop',
    data() {
        return {
            headerTab:false,
            loginPage:false,
            openHeader: false,
        }
    },
    watch:{
			$route(to,form){
                this.openHeader = false
                this.headerTab = ''
			}
	},
    mounted() {
			const _that = this
	        $(document).on("click", function(event){
				if(!$(event.target).closest('.openHeader').length){
	                _that.openHeader = false
	            }
	        });
		}
    
}
</script>





// WEBPACK FOOTER //
// src/components/website/shared/real-account.vue